import styled from "styled-components";

export const ChecklistContainer = styled.div`
  margin-top: 5px;
  font-family: "work sans";
  font-weight: 500;
  color: #293134;
  font-size: 13px;
  span {
    margin-left: 5px;
  }
  li {
    align-items: center;
  }
  @media (min-width: 1900px) {
    margin-top: 10px;
  }
`;

export const EyeContainer = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  cursor: pointer;
  align-items: center;
  height: 35px;
  justify-content: center;
  width: 40px;
  border-radius: 5px;

  @media (min-width: 1900px) {
    height: 40px;
  }
`;
